// extracted by mini-css-extract-plugin
module.exports = {"countryFlag":"country-flag_countryFlag__2042w"};